const reducer = (state: WtrState, action: { isActive: boolean }) => ({
  ...state,
  isDeliveryPassActive: action.isActive,
});

export default reducer;
